import { Link } from "react-router-dom";

const PayBadge = ({ testid, children }) => (
  <span
    data-testid={testid}
    className="flex h-8 items-center gap-1.5 rounded-md bg-bone px-3 text-[10px] font-bold tracking-wide text-charcoal"
  >
    {children}
  </span>
);

export const Footer = () => (
  <footer data-testid="footer" className="bg-charcoal py-32 text-bone">
    <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
      <p className="mb-4 text-xs uppercase tracking-[0.3em] text-bone/50">Delivery</p>
      <p data-testid="footer-delivery-note" className="max-w-3xl font-serif text-3xl font-light leading-tight tracking-tight sm:text-4xl lg:text-5xl">
        Delivered across New York, by hand.
      </p>
      <p className="mt-6 max-w-md text-sm font-light leading-relaxed text-bone/60">
        New York's finest, online — every order is packed, carried and placed in
        your home by our own team. Cashless checkout, careful arrival.
      </p>
      <div className="mt-20 flex flex-wrap gap-10 border-t border-bone/15 pt-10 text-xs uppercase tracking-[0.2em] text-bone/60">
        <Link to="/shop" data-testid="footer-shop-link" className="transition-colors duration-300 hover:text-bone">Shop</Link>
        <a href="/#story" data-testid="footer-story-link" className="transition-colors duration-300 hover:text-bone">About us</a>
        <a href="/#collections" data-testid="footer-collections-link" className="transition-colors duration-300 hover:text-bone">Collections</a>
        <Link to="/track" data-testid="footer-track-link" className="transition-colors duration-300 hover:text-bone">Track order</Link>
        <Link to="/contact" data-testid="footer-contact-link" className="transition-colors duration-300 hover:text-bone">Contact us</Link>
      </div>
      <div className="mt-8 flex flex-wrap gap-x-10 gap-y-4 text-xs uppercase tracking-[0.2em] text-bone/40">
        <Link to="/help" data-testid="footer-help-link" className="transition-colors duration-300 hover:text-bone">Help @ FAQ</Link>
        <Link to="/return-policy" data-testid="footer-return-policy-link" className="transition-colors duration-300 hover:text-bone">Return Policy</Link>
        <Link to="/terms" data-testid="footer-terms-link" className="transition-colors duration-300 hover:text-bone">Terms &amp; Conditions</Link>
        <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors duration-300 hover:text-bone">Privacy Policy</Link>
      </div>
      <p className="mt-24 select-none font-serif text-[13vw] font-light leading-none tracking-tighter text-bone/10 lg:text-[10rem]">
        Shop ONline New York
      </p>
      <div className="mt-16 flex flex-wrap items-center justify-between gap-6 border-t border-bone/15 pt-8">
        <p data-testid="footer-copyright" className="text-xs font-light text-bone/40">
          © 2026 Shop ONline New York. All rights reserved.
        </p>
        <div className="flex flex-wrap items-center gap-2" data-testid="footer-payment-badges">
          <PayBadge testid="pay-visa"><span className="italic">VISA</span></PayBadge>
          <PayBadge testid="pay-mastercard">
            <svg width="24" height="15" viewBox="0 0 26 16" aria-label="Mastercard">
              <circle cx="9" cy="8" r="7" fill="#EB001B" />
              <circle cx="17" cy="8" r="7" fill="#F79E1B" fillOpacity="0.85" />
            </svg>
          </PayBadge>
          <PayBadge testid="pay-amex">AMEX</PayBadge>
          <PayBadge testid="pay-applepay">Apple Pay</PayBadge>
          <PayBadge testid="pay-gpay">G Pay</PayBadge>
        </div>
      </div>
    </div>
  </footer>
);
